import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle" }, null, -1)
const _hoisted_8 = { class: "d-sm-flex flex-row gap-3" }
const _hoisted_9 = { class: "flex-grow-1" }
const _hoisted_10 = { class: "progress bg-danger showLabelStatusBar" }
const _hoisted_11 = ["aria-valuenow"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.uploadInfo !== _ctx.loadingPlaceholder && _ctx.seekResult.labelStatus === _ctx.LabelStatus.OUTSIDE)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _hoisted_1,
        (_ctx.uploadInfo.labelOutsideMandatory)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.$t('review.upload.preview.label.outsideMandatory')), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.$t('review.upload.preview.label.outside')), 1)
            ], 64))
      ], 64))
    : (_ctx.seekResult.labelStatus === _ctx.LabelStatus.IGNORED)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('review.upload.preview.label.labelIgnored')), 1)
        ], 64))
      : (!_ctx.seekResult.supportsType)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.uploadInfo.labelExists)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_3,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('review.upload.preview.label.noTypeSupportWithLabel')), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_4,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('review.upload.preview.label.noTypeSupportWithoutLabel')), 1)
                ], 64))
          ], 64))
        : (!_ctx.uploadInfo.labelExists)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('review.upload.preview.label.noLabel')), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              (_ctx.uploadInfo.labelExists)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_6,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('review.upload.preview.label.finishedWithLabel')), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('review.upload.preview.label.finishedWithoutLabel')), 1)
                  ], 64)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: "progress-bar bg-success",
                      role: "progressbar",
                      style: _normalizeStyle({ width: ((100 / 4) * _ctx.numericStatus) + '%' }),
                      "aria-valuenow": _ctx.numericStatus,
                      "aria-valuemin": "0",
                      "aria-valuemax": "4"
                    }, null, 12, _hoisted_11)
                  ])
                ]),
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('review.upload.preview.label.' + this.seekResult.labelStatus)), 1)
              ])
            ], 64))
}